exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._1XIGRDyjYsUO2s0C7xklt5:active,html[dir] ._1XIGRDyjYsUO2s0C7xklt5:hover{background-color:transparent!important}.YwHe9gbqhw_qkhUP0eGsZ{color:var(--neutralSecondary)!important}", ""]);
// Exports
exports.locals = {
	"disabled": "_1XIGRDyjYsUO2s0C7xklt5",
	"iconDisabled": "YwHe9gbqhw_qkhUP0eGsZ"
};